import { render } from "./TxDetails.vue?vue&type=template&id=3484ad0d&scoped=true"
import script from "./TxDetails.vue?vue&type=script&lang=js"
export * from "./TxDetails.vue?vue&type=script&lang=js"

import "./TxDetails.vue?vue&type=style&index=0&id=3484ad0d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3484ad0d"]])

export default __exports__